import { createSlice } from "@reduxjs/toolkit"
import { useSelector } from "react-redux"

/**
 * Estado inicial del slice de candidato.
 *
 * @property {boolean} reload      Indica si la vista debe recargarse. Se alterna con cada refresh().
 * @property {?number} LoanId ID del candidato seleccionado. Puede ser null si no hay uno cargado.
 * @property {object} loan    Información detallada del candidato cargado.
 */
const initialState = {
	reload: true,
	LoanId: null,
	loan: {},
	reloadFile: true,
	openDetails: false,
}

const LoanSlice = createSlice({
	name: "loan",
	initialState,
	reducers: {
		
		refresh(state) {
			state.reload = !state.reload
		},
		
		refreshFile(state) {
			state.reloadFile = !state.reloadFile
		},

		setLoan(state, action) {
			state.loan = action.payload
		},

		setLoanId(state, action) {
			state.LoanId = action.payload
		},
		setOpenDetails(state, action) {
			state.openDetails = action.payload
		},
	},
})

export default LoanSlice

/**
 * Hook que retorna el estado del slice `loan` desde Redux.
 *
 * @returns {{
 *   reload: boolean,
 *   reloadFile: boolean,
 *   LoanId: (number|null),
 *   loan: (object|null)
 *   openDetails: boolean
 * }}
 *
 * @example
 * const { reload, LoanId, loan } = useReduxLoan();
 */
export const useLoanRedux = () => {
	return useSelector((state) => state.loan)
}